/**
 * Starts empty. Each group must contain at least two valid flattened boolean paths,
 * with its fallback among its keys. Keys must be unique within and across groups,
 * and disjoint from RELEASE_FLAG_KEYS.
 */
export const VARIANT_GROUPS: readonly { keys: readonly string[]; fallback: string }[] = [];

export function findVariantGroup(key: string): (typeof VARIANT_GROUPS)[number] | undefined {
    return VARIANT_GROUPS.find((group) => group.keys.includes(key));
}
